export default {
  1: {
    imgStyle: {
      width: '0.5rem',
      height: '0.5rem',
      border: 0,
    },
    children: {
      0: {
        top: '3.97rem',
        left: '0.44rem',
      },
    },
  },
  2: {
    imgStyle: {
      width: '0.5rem',
      height: '0.5rem',
      border: 0,
    },
    children: {
      0: {
        top: '3.97rem',
        left: '0.44rem',
      },
      1: {
        top: '3.97rem',
        left: '1.04rem',
      },
    },
  },
  3: {
    imgStyle: {
      width: '0.5rem',
      height: '0.5rem',
      border: 0,
    },
    children: {
      0: {
        top: '3.97rem',
        left: '0.44rem',
      },
      1: {
        top: '3.97rem',
        left: '1.04rem',
      },
      2: {
        top: '3.97rem',
        left: '1.64rem',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Editor/components/CropPageView/common/circleStylesLovelandBrochure.ts